module.exports = __webpack_public_path__ + "img/12_55.aeb7f403.png";